import {
  CopilotWorkKind,
  type CopilotWorkFinishedEventInfo,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {getCopilotWorkAutomation} from '../copilot-work-automation'
import {CopilotWorkEventText} from './CopilotWorkEventText'

export function CopilotWorkFinishedEventText({
  info,
  failed = false,
}: {
  info: CopilotWorkFinishedEventInfo
  failed?: boolean
}) {
  const isReview = info.workKind === CopilotWorkKind.REVIEW
  const work = isReview ? 'reviewing' : 'work'
  const actionText = failed
    ? getCopilotWorkAutomation(info)
      ? `stopped ${work} due to an error`
      : `encountered an error${isReview ? ' while reviewing' : ''}`
    : `finished ${work}`

  return (
    <>
      <CopilotWorkEventText info={info} actionText={actionText} />
      {failed && info.errorMessage?.trim() && <>: {info.errorMessage}</>}
    </>
  )
}
